import { Injectable } from '@angular/core';
import { CdnDataDomain } from "@vshosting/models";
import { ApiEntityKeys } from '../../app.constant';
import { EntityService } from '@vshosting/core';

@Injectable({ providedIn: 'root' })
export class DataDomainEntity extends EntityService<CdnDataDomain> {
  constructor() {
    super(ApiEntityKeys.DataDomain);
  }
}
